import { enhancedApi } from '@store/generated/payer-docs';

/**
 * Feature-specific tag types for payer docs cache management
 */
const PAYER_DOC_TAG_TYPES = ['PayerDoc', 'PayerDocList'] as const;

/**
 * Payer Docs API - extends the generated OpenAPI client
 */
export const payerDocsApi = enhancedApi.enhanceEndpoints({
  addTagTypes: PAYER_DOC_TAG_TYPES,
  endpoints: {
    getV2ProviderBillingPayerDocs: {
      providesTags: result =>
        result?.items
          ? [
              ...result.items.map(item => ({
                type: 'PayerDoc' as const,
                id: item.payer_key,
              })),
              { type: 'PayerDocList' as const, id: 'LIST' },
            ]
          : [{ type: 'PayerDocList', id: 'LIST' }],
    },
    getV2ProviderBillingPayerDocsByPayerKey: {
      providesTags: (_result, _error, arg) => [
        { type: 'PayerDoc', id: arg.payerKey },
      ],
    },
  },
});

// Export hooks with user-friendly names
export const {
  useGetV2ProviderBillingPayerDocsQuery: useGetPayerDocsQuery,
  useGetV2ProviderBillingPayerDocsByPayerKeyQuery: useGetPayerDocQuery,
} = payerDocsApi;
